import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Loader, Pagination } from '@components/common';
import { isEqual } from 'lodash';
import classNames from 'classnames';

import { Table } from '@components';

class DetailsJobList extends Component {
	constructor(props) {
		super(props);
		this.columns = props.jobColumns();
	}

	shouldComponentUpdate = ({
		type, loading, data, totalCount, filters, tableHeaderNeeded,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.loading, loading)
			|| !isEqual(lastProps.type, type)
			|| !isEqual(lastProps.data, data)
			|| !isEqual(lastProps.totalCount, totalCount)
			|| !isEqual(lastProps.filters, filters)
			|| !isEqual(lastProps.tableHeaderNeeded, tableHeaderNeeded)
		);
	};

	componentWillUnmount = () => {
		const { type, resetJobHistoryFilters } = this.props;
		if (type === 'jobHistory') resetJobHistoryFilters();
	}

	render() {
		const {
			type,
			loading,
			data,
			totalCount,
			filters : {
				pageNumber,
				displayCount,
			},
			onPaginate,
			tableHeaderNeeded,
		} = this.props;

		return (
			<Fragment>
				<Table
					rowKey="Id"
					className={classNames('compact-row', { 'header-hidden' : !tableHeaderNeeded || !totalCount })}
					columns={this.columns}
					data={data}
				/>
				<Pagination
					className="padding-15"
					totalCount={totalCount}
					displayCount={displayCount}
					pageNumber={pageNumber}
					onPaginate={(pageNo) => onPaginate(pageNo, type)}
				/>
				<Loader active={loading} />
			</Fragment>
		);
	}
}

DetailsJobList.propTypes = {
	type                   : PropTypes.string,
	data                   : PropTypes.array,
	loading                : PropTypes.bool,
	totalCount             : PropTypes.number,
	filters                : PropTypes.object,
	jobColumns             : PropTypes.func.isRequired,
	onPaginate             : PropTypes.func.isRequired,
	resetJobHistoryFilters : PropTypes.func,
	tableHeaderNeeded      : PropTypes.bool,
};

DetailsJobList.defaultProps = {
	type                   : 'activeJobs',
	data                   : [],
	loading                : false,
	totalCount             : 0,
	resetJobHistoryFilters : () => {},
	tableHeaderNeeded      : false,
	filters                : {
		pageNumber   : 1,
		displayCount : 10,
	},
};

export default DetailsJobList;
